import { createClient } from '@supabase/supabase-js'

const supabaseUrl =
  import.meta?.env?.VITE_SUPABASE_URL ||
  'https://girfqqrrzermtlxveatk.supabase.co'

const supabaseKey =
  import.meta?.env?.VITE_SUPABASE_ANON_KEY ||
  'sb_publishable_4dIcA8iUc2lwBAigTJpqbA_1TdH-ORZ'

if (!supabaseUrl || !supabaseKey) {
  throw new Error(
    'Supabase configuration missing. Please set environment variables.',
  )
}

export const supabase = createClient(supabaseUrl, supabaseKey)
